import { Component, AfterViewInit, ChangeDetectorRef, Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import {
  TdLoadingService,
  TdMediaService,
  TdDialogService,
} from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { PatronesService, LoginService, } from '../../../../../services/';
import { Patron } from '../../../../../models';
import { AltaProgramaComponent } from './altaprograma/altaprograma.component';

@Component({
  selector: 'qs-programasdisponibles',
  styleUrls: ['./programasdisponibles.component.scss'],
  templateUrl: './programasdisponibles.component.html',
  viewProviders: [ PatronesService ],
})

export class ProgramasDisponiblesComponent implements AfterViewInit {
  private auxiliarPatrones: any = [];
  private todosLosProgramasPatrones: any = [];
  private auxiliarTodosProgramasPatrones: any = [];

  public mode: string;
  public title: string;
  public idPaciente: string;
  public edadPaciente: string;
  public sexoPaciente: string;
  public tipoEdad: string;
  public idPatron: string;
  public sub: any;

  public patron: Patron;
  public patrones: Patron[];
  public nodes: any = [];
  public searchTerm: string = '';

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.sexoPaciente = this._loginService.consulta.sexo;
    let age: any = this._loginService.consulta.edad;
    let splitted: any = age.split (' ', 2);
    this.edadPaciente = splitted[0];
    let tEdad: any = splitted[1];
    this.tipoEdad = tEdad.charAt(0);

    this._loadingService.register('programasdisponibles.load');
    // this._patronesService.obtenerListadoValoraciones(this.idPaciente, 2).subscribe((res: any) => {
    this._patronesService.obtenerListadoValoraciones(2).subscribe((res: any) => {
      // this.patrones = res.respuesta;

      for (let respuesta in res.respuesta) {
        if (res.respuesta[respuesta].sexo === this.sexoPaciente || res.respuesta[respuesta].sexo === '') {
          if (res.respuesta[respuesta].tipoEdad === this.tipoEdad || res.respuesta[respuesta].tipoEdad === '') {
            if (Number(res.respuesta[respuesta].edadDesde) <= Number(this.edadPaciente) &&
                Number(res.respuesta[respuesta].edadHasta) >= Number(this.edadPaciente)) {
              this.auxiliarPatrones.push({
                id: res.respuesta[respuesta].idPatron,
                name: res.respuesta[respuesta].textoPatron,
                idPadre: res.respuesta[respuesta].idPadre,
                children: [],
              });
            }
          } else if (res.respuesta[respuesta].tipoEdad === undefined) {
            this.auxiliarPatrones.push({
              id: res.respuesta[respuesta].idPatron,
              name: res.respuesta[respuesta].textoPatron,
              idPadre: res.respuesta[respuesta].idPadre,
              children: [],
            });
          }
        }

        this.todosLosProgramasPatrones.push({
          id: res.respuesta[respuesta].idPatron,
          name: res.respuesta[respuesta].textoPatron,
          idPadre: res.respuesta[respuesta].idPadre,
          children: [],
        });
      }

      for (let i: any = 0; i < this.auxiliarPatrones.length; i++) {
        if (this.auxiliarPatrones[i].idPadre === undefined) {
          let patronPadre: any = this.arbol(this.auxiliarPatrones[i]);
          this.nodes.push({
            id: patronPadre.id,
            name: patronPadre.name,
            children: patronPadre.children,
          });
        }
      }

      for (let i: any = 0; i < this.todosLosProgramasPatrones.length; i++) {
        if (this.todosLosProgramasPatrones[i].idPadre === undefined) {
          let patronPadre: any = this.arbolCompleto(this.todosLosProgramasPatrones[i]);
          this.auxiliarTodosProgramasPatrones.push({
            id: patronPadre.id,
            name: patronPadre.name,
            children: patronPadre.children,
          });
        }
      }

      this.nodes.push({
        id: undefined,
        name: 'Todos los P.G.P. Programas, Guías y Protocolos',
        children: this.auxiliarTodosProgramasPatrones,
      });

      this._loadingService.resolve('programasdisponibles.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo programas funcionales.', 'OK', 6000);
      this._loadingService.resolve('programasdisponibles.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  clearSearchInput(input: any, tree: any): void {
    input.value = '';
    tree.collapseAll();
    tree.clearFilter();
    this._changeDetectorRef.detectChanges();
  }

  search(tree: any, key: any): void {
    if (key.length > 2) {
      tree.filterNodes(key, true);
    }
    this._changeDetectorRef.detectChanges();
  }

  selectNode($event: any): void {

      // Abrimos vista detalle de alta
      // Expandimos el la rama
    if ($event.node.hasChildren) {
      if ($event.node.isExpanded) {
        $event.node.collapse();
      } else {
        $event.node.toggleExpanded();
      }
      $event.node.toggleActivated();
    } else {
      this.openDetail($event.node.data);
    }
  }

  /**
   * Abre una vista detalle de la consulta
   * @param patron
   */
  openDetail(patron: any): void {
    let dialogRef: any = this._dialogService.open( AltaProgramaComponent, {
      data: patron,
      width: '92%',
      role: 'dialog',
      height: '90%',
    });
    dialogRef.componentInstance.patron = patron;
    dialogRef.componentInstance.titulo = patron.name;
    dialogRef.componentInstance.idPatron = patron.id;
  }

  close(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
    { outlets: { modanamnesis: ['programasfuncionales'] } }]);
  }

  arbol(patron: any): any {
    for (let i: any = 0; i < this.auxiliarPatrones.length; i++) {
      if (this.auxiliarPatrones[i].idPadre === patron.id) {
        patron.children.push(this.arbol(this.auxiliarPatrones[i]));
      }
    }
    return patron;
  }

  arbolCompleto(patron: any): any {
    for (let i: any = 0; i < this.todosLosProgramasPatrones.length; i++) {
      if (this.todosLosProgramasPatrones[i].idPadre === patron.id) {
        patron.children.push(this.arbolCompleto(this.todosLosProgramasPatrones[i]));
      }
    }
    return patron;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/programasfuncionales/programasdisponibles/programasdisponibles.component.ts